import type { ComponentProps } from 'react';

export const CircularLoaderBase = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="origin-center animate-spin"
        style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}
        d="M24 43C21.5049 43 19.0342 42.5085 16.729 41.5537C14.4238 40.5989 12.3293 39.1993 10.565 37.435C8.80066 35.6707 7.40113 33.5762 6.44629 31.271C5.49145 28.9658 5 26.4951 5 24C5 21.5049 5.49145 19.0342 6.44629 16.729C7.40113 14.4238 8.80066 12.3293 10.565 10.565C12.3293 8.80066 14.4238 7.40113 16.729 6.44629C19.0342 5.49145 21.5049 5 24 5"
        stroke="#FA4969"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        className="origin-center animate-spin"
        style={{ animationDuration: '1.5s' }}
        d="M24 12C22.4241 12 20.8637 12.3104 19.4078 12.9134C17.9519 13.5165 16.629 14.4004 15.5147 15.5147C14.4004 16.629 13.5165 17.9519 12.9134 19.4078C12.3104 20.8637 12 22.4241 12 24C12 25.5759 12.3104 27.1363 12.9134 28.5922C13.5165 30.0481 14.4004 31.371 15.5147 32.4853C16.629 33.5996 17.9519 34.4835 19.4078 35.0866C20.8637 35.6896 22.4241 36 24 36"
        stroke="#18A0FB"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        className="origin-center animate-spin"
        style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}
        d="M24 29C23.3434 29 22.6932 28.8707 22.0866 28.6194C21.48 28.3681 20.9288 27.9998 20.4645 27.5355C20.0002 27.0712 19.6319 26.52 19.3806 25.9134C19.1293 25.3068 19 24.6566 19 24C19 23.3434 19.1293 22.6932 19.3806 22.0866C19.6319 21.48 20.0002 20.9288 20.4645 20.4645C20.9288 20.0002 21.48 19.6319 22.0866 19.3806C22.6932 19.1293 23.3434 19 24 19"
        stroke="#FDC564"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CircularLoader = (props: ComponentProps<'div'>) => {
  return (
    <div
      className="inline-flex flex-col rounded-full bg-white p-1 text-[#031839] shadow-[2px_4px_25px_5px_rgba(0,0,0,0.05)]"
      {...props}
    >
      <CircularLoaderBase />
    </div>
  );
};
